import React from "react";

function TextLimitIndicator({ current, limit }) {
  return (
    <p
      className="position-absolute"
      style={{
        bottom: "-2.5rem",
        right: "0px",
        fontSize: "12px",
        color: "#283046" // Adjust color as needed
      }}
    >
      {current}/{limit}
    </p>
  );
}

export default TextLimitIndicator;
